import { useEffect, useRef } from "react";
import { decryptTextV2 } from "../utils/DecryptV2";

function useChkParam(onChk = () => { }) {
    const onChkRef = useRef(onChk);
    onChkRef.current = onChk;
    const hasRunRef = useRef(false);

    useEffect(() => {
        if (hasRunRef.current) return;
        hasRunRef.current = true;

        const params = new URLSearchParams(window.location.search);
        const chk = params.get("chk");
        if (!chk) return;
        let loginParams = decryptTextV2(chk)
        if (loginParams && loginParams != 'ErrorInDecrypting') {
            loginParams = loginParams.split('~')
            if (loginParams.length >= 5) {
                const body = {
                    Code: loginParams?.[2],
                    LoginID: loginParams?.[3],
                    Password: loginParams?.[4]
                }
                onChkRef.current(body);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

export default useChkParam;